import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/api`;

export const userService = {
  getUsers: async (token, page = 0, limit = 15, search = '') => {
    console.log('getUsers called with:', { page, limit, search });
    const response = await axios.get(`${API_URL}/identity-admin/accounts`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit, search },
      withCredentials: true
    });
    console.log('getUsers response:', response.data);
    return response.data;
  },

  getUser: async (token, email) => {
    if (!email) {
      console.error('getUser called with no email');
      throw new Error('Email is required');
    }
    
    const encodedEmail = encodeURIComponent(email).replace(/%40/g, '@');
    console.log('getUser called for:', email);
    
    try {
      const response = await axios.get(`${API_URL}/users/${encodedEmail}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      console.error('getUser error:', error);
      throw error;
    }
  },

  createUser: async (token, userData) => {
    console.log('createUser called with:', userData);
    const response = await axios.post(`${API_URL}/identity-admin/accounts`, userData, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      withCredentials: true
    });
    return response.data;
  },

  updateUser: async (token, identityId, userData) => {
    console.log('updateUser called with:', { identityId, userData });
    const response = await axios.put(`${API_URL}/identity-admin/accounts/${encodeURIComponent(identityId)}`, userData, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      withCredentials: true
    });
    return response.data;
  },

  setUserPassword: async (token, identityId, password, mustChange = false) => {
    const response = await axios.post(
      `${API_URL}/identity-admin/accounts/${encodeURIComponent(identityId)}/password`,
      { password, must_change: mustChange },
      {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        withCredentials: true
      }
    );
    return response.data;
  },

  checkEmailExists: async (token, email) => {
    const encodedEmail = encodeURIComponent(email).replace(/%40/g, '@');
    console.log('checkEmailExists called for:', email);
    const response = await axios.get(`${API_URL}/users/check-email/${encodedEmail}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.exists;
  }
}; 